uniform vec3 uColor;
uniform float uIntensity;      // 0-1。GSAP でフェード
uniform float uTime;
uniform float uRayCount;       // 放射状スポークの本数
uniform float uSharpness;      // スポークの鋭さ
uniform sampler2D uPerlinTexture;

varying vec2 vUv;

#define TAU 6.2831853

void main()
{
    // 中心原点の座標系（各軸 -1〜1）
    vec2 p = (vUv - 0.5) * 2.0;
    float dist = length(p);
    float angle = atan(p.y, p.x);

    // ペルリンノイズで角度方向を揺らし、不規則にゆっくりうねるレイにする
    float noise = texture2D(uPerlinTexture, vec2(angle / TAU + uTime * 0.008, 0.35)).r;
    float rays = pow(abs(sin(angle * uRayCount * 0.5 + noise * 4.0 + uTime * 0.05)), uSharpness);

    // 中心からの減衰
    float radialFalloff = pow(max(1.0 - dist, 0.0), 2.0);
    float coreGlow = pow(max(1.0 - dist, 0.0), 4.0);

    // ゆっくりした明滅
    float flicker = 0.9 + 0.1 * sin(uTime * 1.6);

    float strength = coreGlow * 1.4 + rays * radialFalloff * 0.9;
    vec3 finalColor = uColor * strength * flicker;

    // 加算ブレンドなので色・アルファ両方に強度を掛ける
    gl_FragColor = vec4(finalColor * uIntensity, strength * uIntensity);
}
